// src/components/Access.jsx

import React from 'react';
import './Access.css';
import { motion } from 'framer-motion';

const Access = ({ isEnglish }) => {
  return (
    <section className="access-section">
      <h2 className="access-title">
        {isEnglish ? 'Access & Area Guide' : 'アクセス・周辺施設'}
      </h2>
      <p className="access-lead">
        {isEnglish
          ? 'Located in the heart of Kanazawa, within walking distance to Kenrokuen and 21st Century Museum.'
          : '兼六園・21世紀美術館へも徒歩圏内。\n金沢観光の拠点として最適なロケーションです。'}
      </p>

      {/* ▼▼▼ メインのアクセス情報エリア（カード＋マップ） ▼▼▼ */}
      <div className="access-container">

        {/* 左側：住所・交通手段の情報カード */}
        <div className="access-info-card">
          <h3 className="hotel-name">
            {isEnglish ? 'Kanazawa Stay Akebono' : '金沢之旅宿 あけぼの'}
          </h3>
          <div className="address-box">
            <p className="postal">〒920-0964</p>
            <p className="address-text">
              {isEnglish
                ? '2-1-17 Hondamachi, Kanazawa, Ishikawa'
                : '石川県金沢市本多町2丁目1-17'}
            </p>
            <p className="landmark">
              {isEnglish
                ? '(Opposite Yugakukan High School)'
                : '（遊学館高校様の正面）'}
            </p>
          </div>

          <div className="transport-list">
            <div className="transport-item">
              <span className="icon">BUS</span>
              <div className="text">
                <strong>{isEnglish ? 'By Bus' : 'バス'}</strong>
                <p>{isEnglish ? '6 min walk from "Hondamachi" stop' : '「本多町」バス停より徒歩約6分'}</p>
              </div>
            </div>
            <div className="transport-item">
              <span className="icon">TAXI</span>
              <div className="text">
                <strong>{isEnglish ? 'By Taxi' : 'タクシー'}</strong>
                <p>{isEnglish ? '12 min from Kanazawa Station' : '金沢駅より約12分'}</p>
              </div>
            </div>
            <div className="transport-item">
              <span className="icon">CAR</span>
              <div className="text">
                <strong>{isEnglish ? 'By Car' : 'お車'}</strong>
                <p>{isEnglish ? 'Free parking for 3 cars' : '無料駐車場 3台完備'}</p>
              </div>
            </div>
          </div>

          <a
            href="https://www.google.com/maps/search/?api=1&query=石川県金沢市本多町2丁目1-17"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-googlemap"
          >
            {isEnglish ? 'Open in Google Maps' : 'Google Mapsで見る'}
          </a>
        </div>

        {/* 右側：マップ埋め込み */}
        <div className="access-map-wrapper">
          <iframe
            title="Akebono Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.940158508728!2d136.6603374!3d36.5555558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff8350054c34623%3A0x9156ff28e9dffe2e!2z6YeR5rKi5LmL5peF5a6_44GC44GR44G844Gu!5e0!3m2!1sja!2sjp!4v1790220670280!5m2!1sja!2sjp"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>

      {/* ▼▼▼ 周辺観光地リスト（デザイン化） ▼▼▼ */}
      <div className="nearby-attractions">
        <h4 className="nearby-title">{isEnglish ? 'Nearby Attractions' : '周辺観光'}</h4>
        <div className="nearby-grid">
          {[
            { name: isEnglish ? 'Kenrokuen Garden' : '兼六園', time: '8 min walk', timeJp: '徒歩8分', desc: isEnglish ? 'Japan’s top 3 gardens' : '日本三名園の一つ' },
            { name: isEnglish ? '21st Century Museum' : '21世紀美術館', time: '8 min walk', timeJp: '徒歩8分', desc: isEnglish ? 'Contemporary Art' : '現代アートの名所' },
            { name: isEnglish ? 'Nishi Chaya District' : 'にし茶屋街', time: '20 min walk', timeJp: '徒歩20分', desc: isEnglish ? 'Geisha district' : '芸妓文化の街並み' },
            { name: isEnglish ? 'Katamachi' : '片町エリア', time: '15 min walk', timeJp: '徒歩15分', desc: isEnglish ? 'Shopping & Dining' : '金沢一の繁華街' },
          ].map((spot, i) => (
            <motion.div
              className="nearby-card"
              key={i}
              whileHover={{ y: -5 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="nearby-header">
                <span className="spot-name">{spot.name}</span>
                <span className="spot-time">{isEnglish ? spot.time : spot.timeJp}</span>
              </div>
              <p className="spot-desc">{spot.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Access;